export default "skymp5-front/0b85949c7624fdcd029208dc91575ea0.gif";